import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function CheckedCircleDashedIcon(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props} fill="none">
      <path
        d="M12 3.5C16.9709 3.5 21 7.53005 21 12.5C21 17.4699 16.9709 21.5 12 21.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 21.5001C7.02908 21.5001 3 17.4701 3 12.5001C3 7.53018 7.02908 3.50012 12 3.50012"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="4 5"
      />
      <path
        d="M8.79993 12.873L11.1739 15.246L15.9199 10.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconWrapper>
  );
}
